module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "scroll-wrap"
  }, [_c('div', {
    ref: "scrollBar",
    staticClass: "container",
    attrs: {
      "id": "scrollBar"
    },
    on: {
      "scroll": _vm.onScroll
    }
  }, [_c('div', {
    staticClass: "article-page",
    attrs: {
      "id": "article3"
    }
  }, [_c('div', {
    staticClass: "closer"
  }, [_c('route-item', {
    attrs: {
      "to": '/main',
      "element": 'main'
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article3', 'click', 'go down')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "social-share social-block",
    class: {
      'open': _vm.openSocial
    }
  }, [(_vm.openSocial) ? _c('ul', {
    staticClass: "social-list"
  }, [_c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "fb",
      "url": "http://weleda.afisha.ru/share",
      "title": "Природная гармония в Швебиш-Гмюнде",
      "image": "/static/img/share/share3.jpg",
      "description": "Уникальный сад, где цветут тысячи лекарственных растений, которые используются в производстве натуральной косметики.",
      "article": "/article3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article3', 'click', 'fb')
      }
    }
  }, [_c('fb')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "vk",
      "url": "http://weleda.afisha.ru/share",
      "title": "Природная гармония в Швебиш-Гмюнде",
      "image": "/static/img/share/share3.jpg",
      "description": "Уникальный сад, где цветут тысячи лекарственных растений, которые используются в производстве натуральной косметики.",
      "article": "/article3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article3', 'click', 'vk')
      }
    }
  }, [_c('vk')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "ok",
      "url": "http://weleda.afisha.ru/share",
      "title": "Природная гармония в Швебиш-Гмюнде",
      "image": "/static/img/share/share3.jpg",
      "description": "Уникальный сад, где цветут тысячи лекарственных растений, которые используются в производстве натуральной косметики.",
      "article": "/article3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article3', 'click', 'ok')
      }
    }
  }, [_c('ok')], 1)], 1), _vm._v(" "), _c('li', [_c('share-link', {
    staticClass: "icon",
    attrs: {
      "network": "tw",
      "url": "http://weleda.afisha.ru/share",
      "title": "Природная гармония в Швебиш-Гмюнде",
      "image": "/static/img/share/share3.jpg",
      "description": "Уникальный сад, где цветут тысячи лекарственных растений, которые используются в производстве натуральной косметики.",
      "article": "/article3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('article3', 'click', 'tw')
      }
    }
  }, [_c('tw')], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "open-social",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleSocial($event)
      }
    }
  }, [_c('p', [_vm._v("Поделиться")]), _vm._v(" "), _c('opensocial')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "video"
  }, [(!_vm.isPlaying) ? _c('div', {
    staticClass: "video-bg"
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlaying) ? _c('div', {
    ref: "button",
    staticClass: "dplayer-bezel-icon",
    on: {
      "click": _vm.playVideo
    }
  }) : _vm._e(), _vm._v(" "), _c('youtube', {
    attrs: {
      "player-width": "560",
      "player-height": "315",
      "video-id": 'TZBmTiKCZ9U',
      "player-vars": {
        autoplay: 0,
        controls: 0,
        showinfo: 0,
        rel: 0
      }
    },
    on: {
      "ready": _vm.ready,
      "ended": _vm.ended
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article2/slides/slide1.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article2/slides/slide2.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article2/slides/slide3.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article2/slides/slide4.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article2/slides/slide5.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article2/slides/slide6.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article2/slides/slide7.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('img', {
    attrs: {
      "src": "static/img/article2/slides/slide8.jpg",
      "alt": ""
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev custom-arrow-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next custom-arrow-next"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "products-block mobile-hidden"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D0%BE%D0%B5-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D0%BB%D0%B8%D1%86%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=face_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '1-Массажное масло с арникой')
      }
    }
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Гармония и гладкость кожи\n                        ")]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D1%8B%D0%B9-%D1%83%D0%B2%D0%BB%D0%B0%D0%B6%D0%BD%D1%8F%D1%8E%D1%89%D0%B8%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC?utm_source=afisha&utm_medium=longread&utm_content=moisture&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '2-Цитрусовый освежающий гель для душа')
      }
    }
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%83/%D1%83%D0%BD%D0%B8%D0%B2%D0%B5%D1%80%D1%81%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC-skin-food?utm_source=afisha&utm_medium=longread&utm_content=skin_food&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '3-Универсальный питательный крем SKIN FOOD')
      }
    }
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Интенсивно ухаживает за сухой и обезвоженной кожей лица, рук и тела\n                        ")]), _vm._v(" "), _vm._m(16)])]), _vm._v(" "), _c('div', {
    staticClass: "products-block desktop-hidden"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperProductOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D0%BE%D0%B5-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D0%BB%D0%B8%D1%86%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=face_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '1-Массажное масло с арникой')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product7.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Деликатное "), _c('br'), _vm._v(" питательное "), _c('br'), _vm._v(" масло для лица\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Гармония и гладкость кожи\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D0%BE%D0%B5-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D0%BB%D0%B8%D1%86%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=face_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                        Подробнее\n                                    ")])])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D1%8B%D0%B9-%D1%83%D0%B2%D0%BB%D0%B0%D0%B6%D0%BD%D1%8F%D1%8E%D1%89%D0%B8%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC?utm_source=afisha&utm_medium=longread&utm_content=moisture&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '2-Цитрусовый освежающий гель для душа')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product8.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Деликатный "), _c('br'), _vm._v(" увлажняющий крем\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Лёгкий увлажняющий крем "), _c('br'), _vm._v(" для ухода за чувствительной кожей\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D1%8B%D0%B9-%D1%83%D0%B2%D0%BB%D0%B0%D0%B6%D0%BD%D1%8F%D1%8E%D1%89%D0%B8%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC?utm_source=afisha&utm_medium=longread&utm_content=moisture&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                        Подробнее\n                                    ")])])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "product-item"
  }, [_c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%83/%D1%83%D0%BD%D0%B8%D0%B2%D0%B5%D1%80%D1%81%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC-skin-food?utm_source=afisha&utm_medium=longread&utm_content=skin_food&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('longread', 'click', '3-Универсальный питательный крем SKIN FOOD')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product9.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                                    Универсальный "), _c('br'), _vm._v("питательный крем "), _c('br'), _vm._v("SKIN FOOD\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                                    Интенсивно ухаживает за сухой и обезвоженной кожей лица, рук и тела\n                                ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%83/%D1%83%D0%BD%D0%B8%D0%B2%D0%B5%D1%80%D1%81%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC-skin-food?utm_source=afisha&utm_medium=longread&utm_content=skin_food&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                                        Подробнее\n                                    ")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })], 1)]), _vm._v(" "), _vm._m(17)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "head"
  }, [_vm._v("\n                    Природная гармония "), _c('br'), _vm._v(" в Швебиш-Гмюнде\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Швебиш-Гмюнд — очень милый небольшой городок с пряничными домиками, в пригороде которого есть сказочный сад. Тот самый, где вот уже почти сто лет создают истинно натуральную косметику")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                        Небольшой старинный городок в пятидесяти километрах от Штутгарта редко попадает в новости — разве что местный фермер получит приз за самую симпатичную овцу в земле Баден-Вюртемберг.                         ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Швебиш-Гмюнд — образец покоя и стабильности: жизнь здесь течет размеренно, в соответствии с сезонами и естественными ритмами природы.                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                        В этом смысле биодинамический сад Weleda на севере города можно считать совершенно «швебиш-гмюндским» предприятием — жизнь его абсолютно подчинена природной логике.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Из всех европейских садов компании тот, что в Германии, — самый большой и биологически разнообразный: 23 га земли и 1000 видов растений, в том числе 140 лекарственных — последние выращивают для производства медицинских препаратов и натуральных косметических продуктов.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Так, большую часть календулы, которые Weleda использует в своих средствах, собирают и перерабатывают, превращая в спиртовую вытяжку и масляный экстракт, именно здесь.\n                        Помимо узнаваемых оранжевых цветов, на открытых полях растет множество однолетних и многолетних культур — терн, гамамелис, эхинацея, боярышник, дудник, чистотел и многие другие.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        В этом саду царит атмосфера любви, счастья и умиротворения, что передается через растения косметике. Все растения в этом саду целебные, даже листья березы\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n                        Для обработки почвы фермеры и садоводы используют только те компоненты, которые образовались естественным путем, а значит, несут в себе энергию природы.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        У любого растения и животного в саду Weleda есть своя продуманная ниша: горец, например, служит своеобразным зонтиком для папоротника, который любит тень и прохладу.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Этот сад лекарственных растений — крупнейший биодинамический сад в Европе. При производстве используется лишь натуральное сырье и неизменная рецептура\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-content"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "src": "static/img/article2/inner-img1.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("\n                            Здесь же у компании самое крупное производство — некоторые травы и цветы, попадая в продукты марки, не всегда успевают осознать разлуку с землей, настолько свежее у компании сырье, и только подобным образом полезные вещества и компоненты растений могут сохранить свои ценные качества. Все растения собираются максимально быстро и вручную, при этом запрещено использование электрического тока и воздействие электромагнитного излучения.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            Словом, к выращиванию растений, их сбору и финальному этапу производства здесь относятся максимально бережно, ведь именно это лежит в основе принципов Weleda — сохраняя природу, создавать натуральную косметику, наполненную силой и энергией тысячи растений.\n                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product7.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                            Деликатное "), _c('br'), _vm._v(" питательное "), _c('br'), _vm._v(" масло для лица\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D0%BE%D0%B5-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D0%BB%D0%B8%D1%86%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=face_oil&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Подробнее\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product8.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                            Деликатный "), _c('br'), _vm._v(" увлажняющий крем\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-desc"
  }, [_vm._v("\n                            Лёгкий увлажняющий крем "), _c('br'), _vm._v(" для ухода за чувствительной кожей\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D1%8B%D0%B9-%D1%83%D0%B2%D0%BB%D0%B0%D0%B6%D0%BD%D1%8F%D1%8E%D1%89%D0%B8%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC?utm_source=afisha&utm_medium=longread&utm_content=moisture&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Подробнее\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/product/product9.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-head"
  }, [_vm._v("\n                    Универсальный "), _c('br'), _vm._v("питательный крем "), _c('br'), _vm._v("SKIN FOOD\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%83/%D1%83%D0%BD%D0%B8%D0%B2%D0%B5%D1%80%D1%81%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC-skin-food?utm_source=afisha&utm_medium=longread&utm_content=skin_food&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Подробнее\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "check"
  }, [_c('div', {
    staticClass: "footnote"
  }, [_c('p', [_vm._v("*Веледа,Скин фуд")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4b67944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/articles/article3.vue
// module id = 553
// module chunks = 1